<template>
  <div id="clock">
    <span class="time h4">{{ time }}</span>
  </div>
</template>

<script>
export default {
  name: "StopWatch",
  data() {
    return {
      time: '00:00',
      timeBegan: null,
      timeStopped: null,
      stoppedDuration: 0,
      started: null,
      running: false,
      initialDuration: 120 * 60 * 1000  // 50 minutes in milliseconds
    }
  },
  created() {
    this.start();
  },
  methods: {
    start() {
      if (this.running) return;
      if (this.timeBegan === null) {
        const currentTime = new Date();
        this.timeBegan = new Date(currentTime.getTime() - this.initialDuration);
      }
      if (this.timeStopped !== null) {
        this.stoppedDuration += (new Date() - this.timeStopped);
      }
      this.started = setInterval(this.clockRunning, 10);
      this.running = true;
    },
    clockRunning() {
      const currentTime = new Date();
      const timeElapsed = new Date(currentTime - this.timeBegan - this.stoppedDuration);
      const hour = timeElapsed.getUTCHours();
      const min = timeElapsed.getUTCMinutes();
      const sec = timeElapsed.getUTCSeconds();
      const ms = timeElapsed.getUTCMilliseconds();

      this.time = this.zeroPrefix(hour, 2) + ":" +
          this.zeroPrefix(min, 2) + ":" +
          this.zeroPrefix(sec, 2);
    },
    zeroPrefix(num, digit) {
      let zero = '';
      for (let i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    }
  }
}
</script>

<style scoped>
/* Add your styles here */
</style>
